import { WebhookEventHelpTip } from './WebhookEventHelpTip';
import {
  EXCLUDED_BUCKET_GUIDE_TITLE,
  excludedBucketGuideParagraphs,
} from '../lib/excluded-bucket-guide';

export function ExcludedBucketHelpTip({
  placement = 'top',
}: {
  placement?: 'top' | 'bottom' | 'left' | 'right';
}) {
  return (
    <WebhookEventHelpTip
      title={EXCLUDED_BUCKET_GUIDE_TITLE}
      paragraphs={excludedBucketGuideParagraphs()}
      placement={placement}
    />
  );
}
